<p-toast />
<div *ngIf="!showCompetitionDetail" class="competitions-table">
<p-toolbar
  [style]="{
    backgroundColor: 'white',
    'margin-bottom': '1rem',
    border: 'none',
    'border-radius': '0.5rem',
    'box-shadow':
      '0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)'
  }"
  class="p-mb-2"
>
  <ng-template pTemplate="left">
    <p-button
      severity="primary"
      label="Crear Evento"
      icon="pi pi-plus"
      class="mr-2"
      (onClick)="openNew()"
    />
  </ng-template>

  <!-- <ng-template pTemplate="right">
    <p-fileUpload
      mode="basic"
      accept="image/*"
      [maxFileSize]="1000000"
      label="Import"
      chooseLabel="Import"
      class="mr-2 inline-block"
    />
    <p-button severity="help" label="Export" icon="pi pi-upload" />
  </ng-template> -->
</p-toolbar>

<p-table
  #dt
  [value]="competitions"
  [rows]="10"
  [paginator]="true"
  [globalFilterFields]="[
    'type',
    'name',
    'startDate',
    'endDate',
    'location',
    'category',
    'registerDates.ordinary.start',
    'registerDates.ordinary.end',
    'registerDates.extraordinary.start',
    'registerDates.extraordinary.end',
    'isOpenToRegister',
    'isPublished'
  ]"
  [(selection)]="competitionSelected"
  [rowHover]="true"
  sortField="startDate"
  [sortOrder]="-1"
  dataKey="id"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [showCurrentPageReport]="true"
  class="p-datatable-sm table'"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">
      <h5 class="m-0">Evento de la modalidad {{ modalidad | titlecase }}</h5>
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search..."
        />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="type" class="table__header">
        Tipo Evento <p-sortIcon field="name" />
      </th>
      <th pSortableColumn="name" class="table__header">Nombre</th>
      <th pSortableColumn="startDate" class="table__header">
        Fecha <p-sortIcon field="startDate" />
      </th>
      <th pSortableColumn="location" class="table__header">
        Lugar <p-sortIcon field="rating" />
      </th>
      <th pSortableColumn="category" class="table__header">
        Categorías <p-sortIcon field="inventoryStatus" />
      </th>
      <th pSortableColumn="registerDates.ordinary.start" class="table__header">
        Inscripción Ordinaria <p-sortIcon field="inventoryStatus" />
      </th>
      <th
        pSortableColumn="registerDates.extraordinary.start"
        class="table__header"
      >
        Inscripción Extraordinaria <p-sortIcon field="inventoryStatus" />
      </th>
      <th pSortableColumn="isPublished" class="table__header">
        Estado publicación <p-sortIcon field="inventoryStatus" />
      </th>
      <th pSortableColumn="isOpenToRegister" class="table__header">
        Estado Inscripción <p-sortIcon field="inventoryStatus" />
      </th>
      <th class="table__header">Acciones</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-competition>
    <tr class="table__row">
      <td>
        {{ getCompetitionType(competition.type)}}
      </td>
      <td>
        {{ competition.name }}
      </td>
      <td>
        {{ competition.startDate | date : "dd/MM/yyyy" }}
        -
        {{ competition.endDate | date : "dd/MM/yyyy" }}
      </td>
      <td>
        {{ competition.location }}
      </td>
      <td>
        {{ getGategoryDescription(competition.categories) }}
      </td>
      <td>
        {{ competition.registerDates.ordinary.start | date : "dd/MM/yyyy" }} -
        {{ competition.registerDates.ordinary.end | date : "dd/MM/yyyy" }}
      </td>
      <td>
        {{
          competition.registerDates.extraordinary.start | date : "dd/MM/yyyy"
        }}
        -
        {{ competition.registerDates.extraordinary.end | date : "dd/MM/yyyy" }}
      </td>
      <td>
        <p-tag
          [rounded]="true"
          [severity]="competition.isPublished ? 'primary' : 'danger'"
          [icon]="competition.isPublished ? 'pi pi-eye' : 'pi pi-eye-slash'"
          [value]="competition.isPublished ? 'Publicado' : 'Oculto'"
        />
      </td>

      <td>
        <p-tag
          [rounded]="true"
          [severity]="competition.isOpenToRegister ? 'primary' : 'danger'"
          [icon]="
            competition.isOpenToRegister ? 'pi pi-check-square' : 'pi pi-times'
          "
          [value]="competition.isOpenToRegister ? 'Inscribiendo' : 'Cerrado'"
        />
      </td>
      <td>
        <p-button
          icon="pi pi-users"
          [rounded]="true"
          [text]="true"
          [raised]="true"
          class="table__button"
          pTooltip="Inscripción" 
          tooltipPosition="bottom" 
          (onClick)="openRegistration(competition)"
        />

        <p-button
        *ngIf="showAdminEventOptions"
        icon="pi pi-pencil"
        [rounded]="true"
        [text]="true"
        [raised]="true"
        severity="warning "
        class="table__button"
        pTooltip="Editar Evento" 
        tooltipPosition="bottom" 
        (onClick)="editCompetition(competition)"
      />

      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">
      {{ competitions ? competitions.length : 0 }} eventos en total.
    </div>
  </ng-template>
</p-table>
</div>
<div *ngIf="showCompetitionForm && modalidad !== 'HOCKEY' && modalidad !== 'ARTISTICO'">
  <app-competition-form
    [isUpdateForm]="isUpdateCompetition"
    [competitionToUpdate]="competitionSelected"
    [categories]="categories"
    [modality]="modalidad"
    [levels]="levels"
    (onCompetitionCreated)="onCompetitionCreated($event)"
    (onFormClosed)="showCompetitionForm = false"
  ></app-competition-form>
</div>

<div *ngIf="showCompetitionForm && modalidad === 'HOCKEY'">
  <app-hockey-competition-form
    [isUpdateForm]="isUpdateCompetition"
    [competitionToUpdate]="competitionSelected"
    [categories]="categories"
    [levels]="levels"
    (onCompetitionCreated)="onCompetitionCreated($event)"
    (onFormClosed)="showCompetitionForm = false"
  ></app-hockey-competition-form>
</div>

<div *ngIf="showCompetitionForm && modalidad === 'ARTISTICO'">
  <app-artistico-competition-form
    [isUpdateForm]="isUpdateCompetition"
    [competitionToUpdate]="competitionSelected"
    [categories]="categories"
    [levels]="levels"
    [events]="events"
    (onCompetitionCreated)="onCompetitionCreated($event)"
    (onFormClosed)="showCompetitionForm = false"
  ></app-artistico-competition-form>
</div>
<div *ngIf="showCompetitionDetail && competitionSelected.modality !== 'HOCKEY'">
  <app-competition-detail
    [competition]="competitionSelected"
    [categories]="categories"
    [Levels]="levels"
    (onFormClosed)="showCompetitionDetail = false"
  ></app-competition-detail>
</div>

<div *ngIf="showCompetitionDetail && competitionSelected.modality === 'HOCKEY'">
  <app-hockey-competition-detail
    [competition]="competitionSelected"
    [categories]="categories"
    [Levels]="levels"
    (onFormClosed)="showCompetitionDetail = false"
  ></app-hockey-competition-detail>
</div>
